const defaultPolicy = {
  policyName: 'Risk Policy nuevo',
  description: 'agrega descripción',
  isActive: false,
  subSegment: 'FIRST_HOME_1_YOUNG_FRENCH_GRACE_MONTHS_12_CREDIT_INSURANCE_FINANCING_0',
  type: 'MORTGAGE',
  interestType: 'COMPOUND',
  graceMonthsInterestMethod: 'NOT_POSTPONED',
  amortizationMethod: 'FRENCH',
  creditInsuranceFeeTermDefinition: 'SHORT',
  isCreditInsuranceAccelerated: false,
  subSegmentConditions: [
    { path: 'offerResponse.loanToValueHome', minValue: 0.8, maxValue: null }, // LTV min
    { path: 'offerResponse.creditAmount', minValue: 100000, maxValue: null } // Monto crédito min
  ],
  lifeInsuranceMonthlyRateRanges: [
    {
      lifeInsuranceMonthlyRate: 0.000195,
      minAge: 0,
      maxAge: 300
    }
  ],
  lifeInsuranceDebtorMonthlyRateRanges: [
    {
      lifeInsuranceMonthlyRate: 0.000076,
      minAge: 0,
      maxAge: 300
    }
  ],
  lifeInsuranceCodebtorMonthlyRateRanges: [
    {
      lifeInsuranceMonthlyRate: 0.000049,
      minAge: 0,
      maxAge: 300
    }
  ],
  lifeInsuranceTypeOfPremium: 'MULTIPLE',
  maximumBackendRatio: 0.5,
  creditTaxRate: 0.19,
  maximumCreditLTV: 1,
  maximumFrontendRatio: 0.3,
  maximumPropertyLTV: 0.9,
  creditMaxAmount: 100000,
  notaryExpenses: 3,
  notaryExpensesPercentage: 0,
  operationalExpensesInterest: 'WITH_INTEREST',
  operationalExpensesNumberOfMonths: 360,
  propertyInsuranceMonthlyRate: 0.000182,
  propertyTypeFactor: 1,
  purpose: 'HOME',
  realEstateExpensesPercentage: 1,
  realEstateExpensesRate: 0.0099,
  segment: 'FIRST_HOME'
};

export default defaultPolicy;
